// WW-166 / WW-159 / WW-161 (Vania 13 Oct 2026 · D-4 QA) · shared "is this
// event past?" rule for the member app. Mirrors the backend source of
// truth at `backend/shared/past_rule.py :: is_event_past` and extends it
// with the WW-161 night rule: a session that ends on the NEXT Nairobi
// day BEFORE 06:00 is the same night as its start, so the event flips
// to past AFTER the end moment, not at midnight.
//
// Rule in prose:
//   1. The event's "last moment" is the latest of end_at, slots[*].end_at,
//      slots[*].start_at, additional_dates[*], start_at.
//   2. isEventPast(ev) === last_moment < now_iso.
//   3. The night rule applies to the FORMATTER, not to this helper, since
//      the end_at itself is already the correct real-world moment — a
//      7pm → 5am party has end_at = next-day 05:00 and this helper will
//      correctly flip it to past at 05:00 Nairobi.
import { nairobiDate } from "./datetime";

function _lastMoment(ev) {
  if (!ev) return "";
  const parts = [];
  if (ev.end_at) parts.push(String(ev.end_at));
  for (const s of ev.slots || []) {
    if (s?.end_at) parts.push(String(s.end_at));
    if (s?.start_at) parts.push(String(s.start_at));
  }
  for (const d of ev.additional_dates || []) {
    if (d) parts.push(String(d));
  }
  if (parts.length === 0 && ev.start_at) return String(ev.start_at);
  if (parts.length === 0) return "";
  // Return the max ISO string. We parse via nairobiDate so a zoneless
  // string is treated as EAT before comparison; equivalent moments
  // with and without a Z suffix sort identically.
  let bestIso = "";
  let bestMs = -Infinity;
  for (const iso of parts) {
    const d = nairobiDate(iso);
    const ms = d ? d.getTime() : -Infinity;
    if (ms > bestMs) { bestMs = ms; bestIso = iso; }
  }
  return bestIso;
}

export function isEventPast(ev, nowIso) {
  const lm = _lastMoment(ev);
  if (!lm) return false;
  const lmDate = nairobiDate(lm);
  if (!lmDate) return false;
  const nowDate = nowIso ? new Date(nowIso) : new Date();
  return lmDate.getTime() < nowDate.getTime();
}

export function isEventUpcomingOrNow(ev, nowIso) {
  return !isEventPast(ev, nowIso);
}
